import React, { HTMLAttributes } from "react";
import "./grid-table-cell.css";

export interface GridTableCellUIProps {
  uiGridArea?: string;
}

export type GridTableCellProps = HTMLAttributes<HTMLDivElement> & GridTableCellUIProps;

/**
 * Simple table cell with padding, ellipsis and responsive tweak.
 */
export default function GridTableCell({
  className,
  uiGridArea,
  style,
  ...rest
}: GridTableCellProps) {
  const classes = ["grid-table-cell", className].filter(Boolean).join(" ");
  return (
    <div
      className={classes}
      style={uiGridArea ? { gridArea: uiGridArea, ...style } : style}
      {...rest}
    />
  );
}
